import Vue from 'vue';
import Plyr from '@vendor/plyr/dist/plyr.polyfilled';
import { Video } from '@core/video';


const heroElements = document.querySelectorAll('[data-trigger="hero"]');
[...heroElements].forEach(el => {
    new Vue({
        el: el,
        data: {
            player: null,
            fullVideo: null,
            fullVideoPlaying: false,
            fullVideoShow: false,
            controlsShown: false,
        },
        mounted() {
            if(this.$refs.fullVideo) {
                this.player = new Plyr(this.$refs.fullVideo);
                this.setupVideo();
                new Video([this.$refs.fullVideo]);
            }

            if(this.$refs.moodVideo) {
                new Video([this.$refs.moodVideo]);
            }
        },
        methods: {
            playPauseVideo() {
                if(this.fullVideo.paused) {
                    // Leave it here for iPhone fullscreen bug
                    //if (navigator.userAgent.match(/(iPhone|iPod)/g)) {
                    //    this.fullVideo.load();
                    //}

                    this.fullVideo.play();
                } else {
                    this.fullVideo.pause();
                }
            },

            closeVideo() {
                this.fullVideo.pause();
                this.fullVideo.currentTime = 0;
                this.fullVideoShow = false;
            },

            setupVideo() {
                this.fullVideo = this.$refs.fullVideo;

                if ( this.fullVideo ) {
                    this.fullVideo.addEventListener('play', () => {
                        this.fullVideoShow = true;
                        this.fullVideoPlaying = true;
                    });
                    this.fullVideo.addEventListener('pause', () => {
                      this.fullVideoPlaying = false;
                    });
                    this.fullVideo.addEventListener('ended', () => {
                      this.fullVideoShow = false;
                      this.fullVideoPlaying = false;
                    });
                    this.fullVideo.addEventListener('webkitendfullscreen', () => {
                      this.fullVideoShow = false;
                      this.fullVideoPlaying = false;
                    });
                }

                this.player.on('controlsshown', () => {
                  this.controlsShown = true;
                });
                this.player.on('controlshidden', () => {
                  this.controlsShown = false;
                });
            }
        },

    });
});




// WEBPACK FOOTER //
// ./themes/wild/assets/js/hero.js